webpackJsonp([246384609461072],{

/***/ 69:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	module.exports = {
	  siteMetadata: {
	    title: 'gmugart',
	    siteUrl: 'https://www.gmugart.com'
	  },
	  plugins: ['gatsby-plugin-react-helmet', 'gatsby-transformer-sharp', 'gatsby-plugin-sharp', 'gatsby-plugin-react-next', 'gatsby-plugin-styled-jsx', 'gatsby-plugin-sass', 'gatsby-plugin-netlify-cms', {
	    resolve: 'gatsby-plugin-sitemap'
	  }, {
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      path: __dirname + '/src/content/blog',
	      name: 'blog'
	    }
	  }, {
	    resolve: 'gatsby-source-filesystem',
	    options: {
	      name: 'images',
	      path: __dirname + '/src/content/blog/images'
	    }
	  },
	  /*{
	      resolve: `gatsby-source-filesystem`,
	      options: {
	          path: `${__dirname}/src/content/proyectos`,
	          name: 'proyectos',
	      }
	  },*/'gatsby-transformer-remark', {
	    resolve: 'gatsby-transformer-remark',
	    options: {
	      plugins: ['gatsby-remark-emoji', 'gatsby-plugin-sharp', {
	        resolve: 'gatsby-remark-relative-images'
	      }, {
	        resolve: 'gatsby-remark-images',
	        options: {
	          maxWidth: 800,
	          showCaptions: true
	        }
	      }, {
	        resolve: 'gatsby-remark-prismjs',
	        options: {
	          // Class prefix for <pre> tags containing syntax highlighting;
	          // defaults to 'language-' (eg <pre class="language-js">).
	          // If your site loads Prism into the browser at runtime,
	          // (eg for use with libraries like react-live),
	          // you may use this to prevent Prism from re-processing syntax.
	          // This is an uncommon use-case though;
	          // If you're unsure, it's best to use the default value.
	          classPrefix: "language-",
	          // This is used to allow setting a language for inline code
	          // (i.e. single backticks) by creating a separator.
	          // This separator is a string and will do no white-space
	          // stripping.
	          // A suggested value for English speakers is the non-ascii
	          // character '›'.
	          inlineCodeMarker: "±",
	          // This lets you set up language aliases.  For example,
	          // setting this to '{ sh: "bash" }' will let you use
	          // the language "sh" which will highlight using the
	          // bash highlighter.
	          aliases: {}
	        }
	      }, {
	        resolve: "gatsby-remark-external-links",
	        options: {
	          target: "_blank",
	          rel: "nofollow"
	        }
	      }]
	
	    }
	  }, {
	    resolve: '@debiki/gatsby-plugin-talkyard',
	    options: {
	      talkyardServerUrl: 'https://comments-demo.talkyard.io'
	    }
	  }, {
	    resolve: 'gatsby-plugin-google-analytics',
	    options: {
	      trackingId: "UA-117339398-1",
	      // Puts tracking script in the head instead of the body
	      head: true,
	      // Setting this parameter is optional
	      anonymize: true,
	      // Setting this parameter is also optional
	      respectDNT: true
	    }
	  }, {
	    resolve: 'gatsby-plugin-google-tagmanager',
	    options: {
	      id: "GTM-PBF6C8L",
	      // Include GTM in development.
	      // Defaults to false meaning GTM will only be loaded in production.
	      includeInDevelopment: true
	    }
	  }, {
	    resolve: 'gatsby-plugin-mailchimp',
	    options: {
	      endpoint: 'https://gorkamg.us12.list-manage.com/subscribe/post?u=61466ee0b86919031e5fc6e17&amp;id=856821eb83' // see instructions section below
	    }
	  },
	  // make sure to put last in the array
	  {
	    resolve: 'gatsby-plugin-netlify',
	    options: {
	      headers: {}, // option to add more headers. `Link` headers are transformed by the below criteria
	      allPageHeaders: [], // option to add headers for all pages. `Link` headers are transformed by the below criteria
	      mergeSecurityHeaders: false, // boolean to turn off the default security headers
	      mergeLinkHeaders: false, // boolean to turn off the default gatsby js headers
	      mergeCachingHeaders: false, // boolean to turn off the default caching headers
	      transformHeaders: function transformHeaders(headers, path) {
	        return headers;
	      }, // optional transform for manipulating headers under each path (e.g.sorting), etc.
	      generateMatchPathRewrites: false // boolean to turn off automatic creation of redirect rules for client only paths
	    }
	  }]
	};
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(97);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(127);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	"use strict";
	
	var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
	// Thanks to:
	// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
	// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
	// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
	exports.validate = function(email)
	{
		if (!email)
			return false;
			
		if(email.length>254)
			return false;
	
		var valid = tester.test(email);
		if(!valid)
			return false;
	
		// Further checking of some things regex can't handle
		var parts = email.split("@");
		if(parts[0].length>64)
			return false;
	
		var domainParts = parts[1].split(".");
		if(domainParts.some(function(part) { return part.length>63; }))
			return false;
	
		return true;
	}

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gatsbyConfig = __webpack_require__(69);
	
	var _gatsbyConfig2 = _interopRequireDefault(_gatsbyConfig);
	
	var _jsonp = __webpack_require__(106);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _emailValidator = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * make a jsonp request to user's mailchimp list
	 * url is a concatenated string of user's gatsby-config.js
	 * options, along with any MC list fields as query params
	 */
	
	var subscribeEmailToMailchimp = function subscribeEmailToMailchimp(url) {
	  return new Promise(function (resolve, reject) {
	    // `param` object avoids CORS issues
	    return (0, _jsonp2.default)(url, { param: 'c' }, function (err, data) {
	      if (err) reject(err);
	      if (data) resolve(data);
	    });
	  });
	};
	
	/*
	 * parse the plugin options to use in our jsonp request
	 */
	
	var getPluginOptions = function getPluginOptions() {
	  // find gatsby-mailchimp plugin options (MC list settings)
	  var options = _gatsbyConfig2.default.plugins.find(function (plugin) {
	    return plugin.resolve === 'gatsby-plugin-mailchimp';
	  }).options;
	
	  var isString = typeof options.endpoint === 'string';
	  if (!isString) {
	    throw 'Mailchimp endpoint required and must be of type string. See repo README for more info.';
	  }
	  return options;
	};
	
	/*
	 * build a query string of MC list fields
	 * ex: '&KEY1=value1&KEY2=value2'
	 * (toUpperCase because that's what MC requires)
	 */
	
	var convertListFields = function convertListFields(fields) {
	  var queryParams = '';
	  for (var field in fields) {
	    queryParams = queryParams.concat('&' + field.toUpperCase() + '=' + fields[field]);
	  }
	  return queryParams;
	};
	
	/*
	 * accept email (String) and additional, optional
	 * Mailchimp list fields (Object)
	 * then make jsonp req with data
	 */
	
	var addToMailchimp = function addToMailchimp(email, fields) {
	  var isEmailValid = (0, _emailValidator.validate)(email);
	  var emailEncoded = encodeURIComponent(email);
	  if (!isEmailValid) {
	    throw 'gatsy-plugin-mailchimp: email must be of type string and a valid email address. See README for more information.';
	  }
	
	  // generate Mailchimp endpoint for jsonp request
	  // note, we change `/post` to `/post-json`
	  // otherwise, Mailchomp returns an error
	
	  var _getPluginOptions = getPluginOptions(),
	      endpoint = _getPluginOptions.endpoint;
	
	  endpoint = endpoint.replace(/\/post/g, '/post-json');
	
	  var queryParams = '&EMAIL=' + emailEncoded + convertListFields(fields);
	  var url = '' + endpoint + queryParams;
	  return subscribeEmailToMailchimp(url);
	};
	
	exports.default = addToMailchimp;

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(96)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyPluginMailchimp = __webpack_require__(102);
	
	var _gatsbyPluginMailchimp2 = _interopRequireDefault(_gatsbyPluginMailchimp);
	
	var _cookiesLink = __webpack_require__(16);
	
	var _cookiesLink2 = _interopRequireDefault(_cookiesLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignUpStatic = function (_React$Component) {
	  _inherits(SignUpStatic, _React$Component);
	
	  function SignUpStatic() {
	    _classCallCheck(this, SignUpStatic);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this._handleEmailChange = function (e) {
	      _this.setState({ email: e.target.value });
	    };
	
	    _this._handleNameChange = function (e) {
	      _this.setState({ name: e.target.value });
	    };
	
	    _this._postEmailToMailchimp = function (email, attributes) {
	      (0, _gatsbyPluginMailchimp2.default)(email, attributes).then(function (result) {
	
	        // Mailchimp always returns a 200 response
	        // So we check the result for MC errors & failures
	        if (result.result !== "success") {
	          _this.setState({
	            status: "error",
	            msg: result.msg
	          });
	        } else {
	          // Email address succesfully subcribed to Mailchimp
	          _this.setState({
	            status: "success",
	            msg: result.msg
	          });
	        }
	      }).catch(function (err) {
	        // Network failures, timeouts, etc
	        _this.setState({
	          status: "error",
	          msg: err
	        });
	      });
	    };
	
	    _this._handleFormSubmit = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        status: "sending",
	        msg: null
	      },
	      // setState callback (subscribe email to MC)
	      _this._postEmailToMailchimp(_this.state.email, {
	        PATH: document.location.pathname,
	        FIRST_NAME: _this.state.name,
	        'group[15725][1]': _this.state.consent
	      }));
	    };
	
	    _this.state = {
	      email: "",
	      name: ""
	      /*consent: ' '*/
	    };
	    return _this;
	  }
	
	  // Update state each time user edits their email address
	
	
	  /*
	  _handleConsentChange = e => {
	    this.setState(prevState => ({
	      consent: prevState.consent == 'He leído y acepto la política de privacidad'?'':'He leído y acepto la política de privacidad'
	    }))
	  }
	  */
	
	  // Post to MC server & handle its response
	
	
	  SignUpStatic.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "sign_up" },
	      this.state.status === "success" ? _react2.default.createElement(
	        "div",
	        null,
	        "\xA1Gracias! Recibir\xE1s el email de confirmaci\xF3n en unos instantes. Si no has recibido el email puede que haya sido enviado a la carpeta de spam o a la papelera. ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        " Una vez confirmes tu suscripci\xF3n podr\xE1s actualizar tus preferencias en cualquier momento desde los emails."
	      ) : _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          this.props.message
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            id: "email-capture",
	            method: "post",
	            noValidate: true
	          },
	          _react2.default.createElement(
	            "div",
	            null,
	            _react2.default.createElement(
	              "div",
	              { className: "form-control" },
	              _react2.default.createElement(
	                "label",
	                null,
	                "Email:"
	              ),
	              _react2.default.createElement("input", {
	                type: "email",
	                name: "EMAIL",
	                placeholder: "ejemplo@email.com",
	                onChange: this._handleEmailChange
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-control" },
	              _react2.default.createElement(
	                "label",
	                null,
	                "Nombre:"
	              ),
	              _react2.default.createElement("input", {
	                type: "text",
	                name: "FIRST_NAME",
	                placeholder: "Nombre",
	                onChange: this._handleNameChange
	              })
	            ),
	            _react2.default.createElement(
	              "button",
	              {
	                type: "submit",
	                onClick: this._handleFormSubmit
	              },
	              "Suscribirme"
	            ),
	            this.state.status === "error" && _react2.default.createElement("div", {
	              dangerouslySetInnerHTML: { __html: this.state.msg }
	
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return SignUpStatic;
	}(_react2.default.Component);
	
	exports.default = SignUpStatic;
	
	/*
	const SignUpStatic = ()=> (
	    <div>
	<form>
	    <h4>Recibe la newsletter</h4>
	    <label for="email">Email:</label>
	    <input type="email" id="email"/>
	</form>
	</div>
	)*/
	
	/*
	export default class SignUpStatic extends React.Component {
	  // Since `addToMailchimp` returns a promise, you
	  // can handle the response in two different ways:
	
	  // Note that you need to send an email & optionally, listFields
	  // these values can be pulled from React state, form fields,
	  // or wherever.  (Personally, I recommend storing in state).
	
	  // 1. via `.then`
	  _handleSubmit = e => {
	    e.preventDefault;
	    addToMailchimp(email, {FNAME: 'Ben',  LNAME: 'Bordeaux'})
	    .then(data => {
	      // I recommend setting data to React state
	      // but you can do whatever you want
	      console.log(data)
	    })
	    .catch(() => {
	      // unnecessary because Mailchimp only ever
	      // returns a 200 status code
	      // see below for how to handle errors
	    })
	  }
	
	// 2. via `async/await`
	  _handleSubmit = async (e) => {
	    e.preventDefault;
	    const result = await addToMailchimp(email, listFields)
	    // I recommend setting `result` to React state
	    // but you can do whatever you want
	  }
	
	  render () {
	    return (
	      <form onSubmit={this._handleSubmit(email, {listFields})}>
	        Example
	      </form>
	    )
	  }
	}
	*/
	//export default SignUpStatic
	
	module.exports = exports["default"];

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = CookiesLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CookiesLink() {
	        return _react2.default.createElement(
	                "a",
	                { href: "https://www.iubenda.com/privacy-policy/25482128",
	                        className: "iubenda-white iubenda-embed ",
	                        title: "Privacy Policy" },
	                "Pol\xEDtica de Privacidad y Cookies"
	        );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = NextStaticPage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NextStaticPage(props) {
	    return _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: "next-static-page", to: "/" + props.to + "/" },
	        props.text
	    );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _signUpStatic = __webpack_require__(71);
	
	var _signUpStatic2 = _interopRequireDefault(_signUpStatic);
	
	var _nextStaticPage = __webpack_require__(33);
	
	var _nextStaticPage2 = _interopRequireDefault(_nextStaticPage);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioPage = function PortfolioPage() {
	  return _react2.default.createElement(
	    'div',
	    { style: { margin: '3rem auto', maxWidth: 960 } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Portfolio | @gmugart'
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(_signUpStatic2.default, { message: '\xA1Portfolio en camino! Suscribete a la newsletter y ser\xE1s el primero en enterarte de la publicaci\xF3n. ' })
	    ),
	    _react2.default.createElement(_nextStaticPage2.default, { to: 'sobre-mi', text: 'M\xE1s sobre gmugart' })
	  );
	};
	
	exports.default = PortfolioPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-17ccf6444736b0e3ff80.js